import * as url from "../../url_helper"
import { request } from "../../api_helper"

export const showCompany = () => request({ url: url.COMPANY, method: "GET" })

export const updateCompany = data =>
  request({ url: url.COMPANY, method: "PUT", data })
